import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { IRound } from "../interfaces";
import { RoundRepository } from "../round.repository";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable()
export class GetRoundIdUseCase implements IUseCase<void, Observable<string | undefined>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(): Observable<string | undefined> {
        return this.roundRepository.get().pipe(map((round: IRound) => round.roundId));
    }
}
